import React from 'react';

export default function BestResourceIcon({ width = 46, height = 46 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7199_20408)">
        <path
          d="M23.0014 45.4262C35.3855 45.4262 45.4248 35.387 45.4248 23.0029C45.4248 10.6189 35.3855 0.57959 23.0014 0.57959C10.6174 0.57959 0.578125 10.6189 0.578125 23.0029C0.578125 35.387 10.6174 45.4262 23.0014 45.4262Z"
          fill="#F15A42"
        />
        <mask
          id="mask0_7199_20408"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="-2"
          y="-2"
          width="50"
          height="50"
        >
          <path
            d="M23.0015 46.4262C35.9378 46.4262 46.4248 35.9393 46.4248 23.0029C46.4248 10.0666 35.9378 -0.42041 23.0015 -0.42041C10.0651 -0.42041 -0.421875 10.0666 -0.421875 23.0029C-0.421875 35.9393 10.0651 46.4262 23.0015 46.4262Z"
            fill="#3F5DB9"
            stroke="black"
            strokeWidth="2"
          />
        </mask>
        <g mask="url(#mask0_7199_20408)"></g>
        <path
          d="M7.63412 7.63659L7.63414 7.63656C11.7387 3.53075 17.1952 1.2709 23.0002 1.2709C28.8052 1.2709 34.263 3.53075 38.3675 7.63656L38.4383 7.56586L38.3675 7.63658C42.4721 11.7411 44.7332 17.1989 44.7332 23.0039C44.7332 28.8089 42.4734 34.2667 38.3676 38.3713L38.4383 38.442L38.3675 38.3713C34.263 42.4758 28.8052 44.7369 23.0002 44.7369C17.1952 44.7369 11.7374 42.4771 7.63286 38.3713C3.52831 34.2655 1.26846 28.8077 1.26846 23.0026C1.26846 17.1976 3.52831 11.7411 7.63412 7.63659ZM23.0002 0.558691C10.6045 0.558691 0.55625 10.607 0.55625 23.0026C0.55625 35.3983 10.6045 45.4466 23.0002 45.4466C35.3959 45.4466 45.4441 35.3983 45.4441 23.0026C45.4441 10.607 35.3959 0.558691 23.0002 0.558691Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
        />
        <path
          d="M23.0026 27.8776L22.9153 27.7206L22.3201 26.651C21.6348 25.4198 20.6338 24.3886 19.4229 23.6698L19.4229 23.6698L18.4383 23.0848L18.2936 22.9989L18.4383 22.9129L19.4229 22.3279C20.6339 21.6074 21.6365 20.5778 22.32 19.3469L22.3201 19.3468L22.9153 18.2771L23.0026 18.1201L23.09 18.2771L23.6852 19.3468C23.6852 19.3468 23.6852 19.3468 23.6852 19.3468C24.3705 20.5779 25.3715 21.6091 26.5823 22.3279L26.5824 22.3279L27.567 22.9129L27.7117 22.9989L27.567 23.0848L26.5824 23.6698L23.0026 27.8776ZM23.0026 27.8776L23.09 27.7206M23.0026 27.8776L23.09 27.7206M23.09 27.7206L23.6852 26.651L23.6853 26.6509M23.09 27.7206L23.6853 26.6509M23.6853 26.6509C24.3687 25.42 25.3714 24.3904 26.5824 23.6698L23.6853 26.6509ZM33.699 23.0865L34.6836 23.6715C34.6836 23.6715 34.6837 23.6715 34.6837 23.6715C37.0852 25.099 38.5766 27.7176 38.5766 30.5051C38.5766 34.8849 35.0128 38.4504 30.6313 38.4504C27.7495 38.4504 25.0859 36.8835 23.6835 34.3593L23.6835 34.3592L23.0883 33.2896L23.0009 33.1326L22.9136 33.2896L22.3184 34.3592L22.3183 34.3593C20.916 36.8835 18.2524 38.4504 15.3706 38.4504C10.9907 38.4504 7.42526 34.8866 7.42526 30.5051C7.42526 27.7176 8.91668 25.099 11.3182 23.6715C11.3182 23.6715 11.3182 23.6715 11.3182 23.6715L12.3028 23.0865L12.4475 23.0006L12.3028 22.9146L11.3182 22.3296C11.3182 22.3296 11.3182 22.3296 11.3182 22.3296C8.91668 20.9021 7.42526 18.2836 7.42526 15.496C7.42526 11.1162 10.9891 7.55073 15.3706 7.55073C18.2524 7.55073 20.916 9.11763 22.3183 11.6418L22.3184 11.6419L22.9136 12.7115L23.0009 12.8686L23.0883 12.7115L23.6835 11.6419L23.6835 11.6418C25.0859 9.11763 27.7495 7.55073 30.6313 7.55073C35.0111 7.55073 38.5766 11.1145 38.5766 15.496C38.5766 18.2836 37.0852 20.9021 34.6837 22.3296C34.6837 22.3296 34.6836 22.3296 34.6836 22.3296L33.699 22.9146L33.5543 23.0006L33.699 23.0865ZM30.6313 6.67051C27.3746 6.67051 24.5302 8.43519 23.0026 11.0611C21.4734 8.43686 18.6307 6.67051 15.374 6.67051C10.4994 6.67051 6.54844 10.6214 6.54844 15.496C6.54844 18.6671 8.22102 21.4452 10.7309 23.0006C8.22102 24.5559 6.54844 27.334 6.54844 30.5051C6.54844 35.3797 10.4994 39.3306 15.374 39.3306C18.6307 39.3306 21.475 37.5659 23.0027 34.94C24.5319 37.5643 27.3746 39.3306 30.6313 39.3306C35.5059 39.3306 39.4568 35.3797 39.4568 30.5051C39.4568 27.334 37.7842 24.5559 35.2744 23.0006C37.7842 21.4452 39.4568 18.6671 39.4568 15.496C39.4568 10.6214 35.5059 6.67051 30.6313 6.67051ZM23.0026 26.0703C22.2735 24.8185 21.2453 23.7629 20.0153 23.0006C21.2453 22.2383 22.2735 21.1826 23.0026 19.9309C23.7318 21.1826 24.76 22.2383 25.9899 23.0006C24.76 23.7629 23.7318 24.8185 23.0026 26.0703Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
        />
        <path
          d="M30.6998 20.0807C33.4938 20.0807 35.7589 17.8156 35.7589 15.0215C35.7589 12.2275 33.4938 9.9624 30.6998 9.9624C27.9057 9.9624 25.6406 12.2275 25.6406 15.0215C25.6406 17.8156 27.9057 20.0807 30.6998 20.0807Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M19.1917 20.0809H12.9813C12.9813 20.0809 16.0406 17.7188 17.5643 16.241C18.1577 15.6475 18.5251 14.8262 18.5251 13.9198C18.5251 12.107 17.0558 10.6377 15.243 10.6377C13.4302 10.6377 11.9609 12.107 11.9609 13.9198"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M19.1917 35.1443H12.9813C12.9813 35.1443 16.0406 32.7823 17.5643 31.3045C18.1577 30.711 18.5251 29.8896 18.5251 28.9832C18.5251 27.1704 17.0558 25.7012 15.243 25.7012C13.4302 25.7012 11.9609 27.1704 11.9609 28.9832"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M34.0619 32.112H27.1406L32.2049 25.8999V35.1441"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_7199_20408">
          <rect width="45" height="45" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
